import axiosInstance from "services/AxiosInstance";

export const getImportService = async (importId: string) => {
  const requestUrl = `/imports/${importId}`;
  const response = await axiosInstance.get(requestUrl);
  return response.data;
};
